// Restored from production OTA 2026-08-21 (module 1437); lost in the 2026-08-30 incident.
import {
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILED,
  EDIT_ADDRESS
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, off, push, remove } from "firebase/database";

export const fetchAddresses = () => (dispatch) => {
  const { addressEditRef } = firebase;

  dispatch({
    type: FETCH_ADDRESSES,
    payload: null
  });
  const uid = store.getState().auth.profile.uid;
  // Detach first: this runs again after every profile change.
  off(addressEditRef(uid));
  onValue(addressEditRef(uid), (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map((i) => {
        data[i].id = i;
        return data[i];
      });
      dispatch({
        type: FETCH_ADDRESSES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ADDRESSES_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_address
      });
    }
  });
};

export const editAddress = (uid, address, method) => async (dispatch) => {
  const { addressRef, addressEditRef } = firebase;
  dispatch({
    type: EDIT_ADDRESS,
    payload: { method, address }
  });
  if (method === 'Add') {
    push(addressEditRef(uid), address);
  } else if (method === 'Delete') {
    remove(addressRef(uid, address.id));
  }
};
